export enum Companies {
  PLACEHUB = 'placehub',
  DEZKER = 'dezker',
}
